__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['one-commercial-payments-enrollment-root'].baseUrl;
import ModuleContainer from './components/OneCommercialPaymentsEnrollmentRoot';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "^5.0.0"
  });
}
;
ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
  providedExternals: {
    '@americanexpress/one-experiments': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '2.8.1',
      module: require('@americanexpress/one-experiments')
    },
    'reactlytics': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.2.5',
      module: require('reactlytics')
    },
    '@americanexpress/react-ddl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.3.7',
      module: require('@americanexpress/react-ddl')
    }
  }
});
if (global.getTenantRootModule === undefined || global.rootModuleName && global.rootModuleName === 'one-commercial-payments-enrollment-root') {
  global.getTenantRootModule = () => ModuleContainer;
  global.rootModuleName = 'one-commercial-payments-enrollment-root';
}